module.exports = __webpack_public_path__ + "static/step2-4a22d0c16e199e678e49098bcbacc375.svg";